<div class="d-flex flex-wrap gap-3 company-branch-selector">
    <div class="d-flex align-items-center gap-2 flex-fill" style="min-width:220px;">
        <label class="form-label mb-0">Company</label>
        <select class="form-select form-select-sm" [(ngModel)]="selectedCompanyId" (change)="onCompanyChange()" [disabled]="accountService.isCompanyAdmin()">
            <option value="">Select Company</option>
            <option *ngFor="let company of companies" [value]="company.id">
                {{company.name}}
            </option>
        </select>
    </div>
    <div class="d-flex align-items-center gap-2 flex-fill" style="min-width:220px;">
        <label class="form-label mb-0">Branch</label>
        <select class="form-select form-select-sm" [(ngModel)]="selectedBranchId" (change)="onBranchChange()" [disabled]="!selectedCompanyId">
            <option value="">Select Branch</option>
            <option *ngFor="let branch of branches" [value]="branch.id">
                {{branch.name}}
            </option>
        </select>
    </div>
</div>
